<app-home-button-card
  *ngIf="currentUser"
  [currentUser]="currentUser"
></app-home-button-card>
